import React, { useState, useCallback } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { AuditPermissionRole } from '@scale/shared/taskerScreening/types';
import { Button } from '@scale/scaleui';
import API from '@scale/frontend-lib/dashboard-api';
import TaskerScreeningAuditPermissionRoleCreationModal from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningAuditPermissionRoleCreationModal';

interface TaskerScreeningAuditPermissionRoleToolProps {
  user: IUserJson;
  setNeedsFetch: (needsFetch: boolean) => void;
}

const defaultRole: AuditPermissionRole = {
  id: '',
  name: '',
  description: '',
  courseIds: [],
  sectionTitles: [],
  createdBy: '',
  createdAt: new Date(),
};

const TaskerScreeningAuditPermissionRoleTool: React.FC<
  TaskerScreeningAuditPermissionRoleToolProps
> = ({ setNeedsFetch }) => {
  const [createModalOpen, setCreateModalOpen] = useState<boolean>(false);
  const [role, setRole] = useState<AuditPermissionRole>(defaultRole);

  const publishRole = async (role: AuditPermissionRole) => {
    await API.genai.publishAuditPermissionRole({
      name: role.name,
      description: role.description,
      courseIds: role.courseIds,
      sectionTitles: role.sectionTitles,
    });
  };

  const handlePublishRole = useCallback(async () => {
    setCreateModalOpen(false);
    await publishRole(role);
    setNeedsFetch(true);
  }, [role, setNeedsFetch]);

  return (
    <div>
      <Button
        className="mt-4"
        variant="primary"
        onClick={() => {
          setCreateModalOpen(true);
        }}
      >
        Create Permission Role
      </Button>
      <TaskerScreeningAuditPermissionRoleCreationModal
        role={role}
        setRole={setRole}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onPublish={handlePublishRole}
      />
    </div>
  );
};

export default TaskerScreeningAuditPermissionRoleTool;
